import { render, staticRenderFns } from "./todo-input.vue?vue&type=template&id=66786ada&"
import script from "./todo-input.vue?vue&type=script&lang=ts&"
export * from "./todo-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports